<template>
  <span class="inline-flex flex-wrap gap-1">
    <span v-for="d in dims" :key="d" class="chip" :style="styleOf(d)">{{ short ? d : 'มิติ' + d }}</span>
    <span v-if="!dims.length && placeholder" class="chip chip-muted">{{ placeholder }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";
import { DIMENSION_STYLE } from "../constants";

const props = defineProps({
  dimensions: { type: [Array, String], default: () => [] },
  short: { type: Boolean, default: true },
  placeholder: { type: String, default: "" },
});
const dims = computed(() => (Array.isArray(props.dimensions) ? props.dimensions : props.dimensions ? [props.dimensions] : []).filter(Boolean));
const styleOf = (d) => DIMENSION_STYLE[d] || { color: "#415A77", background: "#eef1f6" };
</script>
